import { viewportObserver } from '@nova/utils'

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
    this.recommendUrl = this.getAttribute('data-url')
    this.recommendationContainer = this.querySelector(
      '[data-recommendations-container]',
    )
    this.loadRecommendations()
  }

  getSlidesPerPage(viewport) {
    let base = 1
    let peek = 0

    switch (viewport) {
      case 'mobile':
        base = Number(this.dataset.slidesMobile) || 1
        peek = Number(this.dataset.peekMobile) || 0
        break
      case 'tablet':
        base = Number(this.dataset.slidesTablet) || 2
        peek = Number(this.dataset.peekMobile) || 0
        break
      default:
        base = Number(this.dataset.slidesDesktop) || 4
        peek = Number(this.dataset.peekDesktop) || 0
    }

    return base + peek
  }

  loadRecommendations() {
    fetch(this.recommendUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        const recommendedContent = html.querySelector(
          '[data-recommendations-container]',
        )
        if (recommendedContent) {
          this.recommendationContainer.innerHTML = recommendedContent.innerHTML
        }

        const resizeObserver = this.recommendationContainer.querySelector(
          '.js-resize-observer',
        )

        const carousel =
          this.recommendationContainer.querySelector('.js-carousel')

        const syncCarouselLayout = () => {
          if (!carousel) return

          const viewport = viewportObserver.getCurrentViewport()
          const slidesPerPage = this.getSlidesPerPage(viewport)
          const value = String(slidesPerPage)

          if (carousel.getAttribute('slides-per-page') !== value) {
            carousel.setAttribute('slides-per-page', value)
          }

          requestAnimationFrame(() => {
            carousel.dispatchEvent(
              new CustomEvent('sl-resize', { bubbles: true, composed: true }),
            )
          })
        }

        syncCarouselLayout()
        resizeObserver?.addEventListener('sl-resize', syncCarouselLayout)

        const cards =
          this.recommendationContainer.querySelectorAll('nova-product-card')
        const getTemplateData = (name, id) => {
          const template = this.recommendationContainer.querySelector(
            `#${name}-json-${id}`,
          )
          return template ? JSON.parse(template.content.textContent.trim()) : []
        }
        for (const card of cards) {
          const swatchValues = getTemplateData('swatch-values', card.id)
          const sizeValues = getTemplateData('size-values', card.id)
          const variants = getTemplateData('variants', card.id)
          card.swatches = swatchValues
          card.sizes = sizeValues
          card.variants = variants
        }

        requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('orp:product-grid-updated'))
          syncCarouselLayout()
        })

        requestAnimationFrame(() => {
          if (!carousel?.shadowRoot) return

          const carouselNavButtons = carousel.shadowRoot.querySelectorAll(
            '.carousel__navigation-button',
          )

          for (const button of carouselNavButtons) {
            if (
              button.classList.contains('carousel__navigation-button--disabled')
            )
              button.style.opacity = '0'
          }

          const handleMutation = (mutationsList) => {
            for (const mutation of mutationsList) {
              if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class'
              ) {
                const targetButton = mutation.target

                if (
                  targetButton.classList.contains(
                    'carousel__navigation-button--disabled',
                  )
                ) {
                  targetButton.style.opacity = '0'
                } else {
                  targetButton.style.opacity = '1'
                }
              }
            }
          }
          const observer = new MutationObserver(handleMutation)
          for (const button of carouselNavButtons) {
            observer.observe(button, {
              attributes: true,
              attributeFilter: ['class'],
            })
          }
        })
      })
  }
}

customElements.define('nova-product-recommendations', ProductRecommendations)
